// extracted by mini-css-extract-plugin
module.exports = {"top":"UniverseHeading_top__uQ9QE","overview":"UniverseHeading_overview__UFs9e","breadcrumb":"UniverseHeading_breadcrumb__I_QSW","title_box":"UniverseHeading_title_box___P1TQ"};